"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ParcelBoundary;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useParcelBuffer3 = _interopRequireDefault(require("./useParcelBuffer"));

// $FlowFixMe - useMemo is a named export of react
function ParcelBoundary(props) {
  var parcel = props.parcel,
      children = props.children,
      _props$pure = props.pure,
      pure = _props$pure === void 0 ? true : _props$pure,
      _props$forceUpdate = props.forceUpdate,
      forceUpdate = _props$forceUpdate === void 0 ? [] : _props$forceUpdate,
      _props$buffer = props.buffer,
      buffer = _props$buffer === void 0 ? false : _props$buffer,
      _props$debounce = props.debounce,
      debounce = _props$debounce === void 0 ? 0 : _props$debounce,
      _props$beforeChange = props.beforeChange,
      beforeChange = _props$beforeChange === void 0 ? [] : _props$beforeChange,
      _props$modifyBeforeUp = props.modifyBeforeUpdate,
      modifyBeforeUpdate = _props$modifyBeforeUp === void 0 ? [] : _props$modifyBeforeUp,
      _props$keepValue = props.keepValue,
      keepValue = _props$keepValue === void 0 ? false : _props$keepValue; // deprecation notice

  if (process.env.NODE_ENV !== 'production' && modifyBeforeUpdate.length > 0) {
    console.warn("ParcelBoundary.modifyBeforeUpdate is deprecated. Please use ParcelBoundary.beforeChange instead");
    /* eslint-disable-line no-console */

    beforeChange = beforeChange.concat(modifyBeforeUpdate);
  }

  var _useParcelBuffer = (0, _useParcelBuffer3.default)({
    parcel: parcel,
    debounce: debounce,
    buffer: buffer,
    beforeChange: beforeChange,
    keepValue: keepValue
  }),
      _useParcelBuffer2 = (0, _slicedToArray2.default)(_useParcelBuffer, 2),
      innerParcel = _useParcelBuffer2[0],
      parcelBufferControl = _useParcelBuffer2[1];

  var renderChildren = function renderChildren() {
    return children(innerParcel, parcelBufferControl);
  };

  var memoed = (0, _react.useMemo)(function () {
    return pure && renderChildren();
  }, [innerParcel].concat((0, _toConsumableArray2.default)(forceUpdate)));
  return pure ? memoed : renderChildren();
}